import InlineTooltip from '../../common/InlineTooltip';
import SearchPagination from './SearchPagination';
import { renderRow } from './SearchResultsRow';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { connect } from 'react-redux';

const SearchVolunteerPeerResults = ({ onPageChange, page, peers, searching, limit }) => {
  const changePage = useCallback(
    (pageNum) => () => {
      if (!searching) {
        onPageChange(pageNum);
      }
    },
    [onPageChange, searching],
  );

  if (!peers) return null;

  const renderSearchResultTitle = (numResults) => {
    return numResults !== 0 && parseInt(numResults)
      ? `${numResults} ${numResults === 1 ? 'practitioner' : 'practitioners'} match your search criteria`
      : 'There are not any volunteers available at present';
  };

  const { matches } = peers;

  return (
    <section className="PractitionerController">
      <div className="col-lg-12">
        <h2>{renderSearchResultTitle(peers.totalItems)}</h2>
        {matches.map((match) => (
          <div style={{ padding: '15px 0' }} key={match['Person ID']}>
            <h3>
              {match.FirstName} {match.Surname}
            </h3>
            <table className="practitioner-result">
              <tbody>
                <tr>
                  <th>Person ID:</th>
                  <td>{match['Person ID']}</td>
                </tr>
                {match.Contact && (
                  <tr>
                    <th>Contact:</th>
                    <td style={{ whiteSpace: 'pre-line' }}>{match.Contact}</td>
                  </tr>
                )}
              </tbody>
            </table>

            {match.Practices.map((practice, index) => (
              // Odoo practice rows have no guaranteed unique id; index is acceptable for this static list
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <table className="practitioner-result" key={index}>
                <tbody>
                  {practice.Practice && (
                    <tr>
                      <th colSpan="2">
                        <h4>{practice.Practice}</h4>
                      </th>
                    </tr>
                  )}
                  {renderRow('Scope of Practice Registration date:', practice.RegistrationDate)}
                  {renderRow(<InlineTooltip>Qualification(s):</InlineTooltip>, practice.Qualifications)}
                  {renderRow('Scope of Practice Registration date:', practice.RegistrationDate)}
                  {renderRow('Health Provider Index number:', practice.HPINumber)}
                  {renderRow('Registration Status:', practice.Status)}
                  {renderRow('Practising Status:', practice.APCStatus)}
                  {renderRow('Annual Practising Certificate Period:', practice.APCPeriod)}
                </tbody>
              </table>
            ))}

            <table className="practitioner-result">
              <tbody>
                {renderRow('City:', match.City)}
                {renderRow('Suburb:', match.Suburb)}
                {renderRow('Territorial authority:', match.TerritorialAuthority)}
                {renderRow('DHB:', match.DHB)}
              </tbody>
            </table>
          </div>
        ))}
        <div className="clearfix" />
        <SearchPagination changePage={changePage} limit={limit} page={page} results={peers} searching={searching} />
      </div>
    </section>
  );
};

SearchVolunteerPeerResults.propTypes = {
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  peers: PropTypes.object,
  searching: PropTypes.bool,
  limit: PropTypes.number,
};

const mapStateToProps = (state) => ({
  peers: state.odooForm.peers,
});

export default connect(mapStateToProps)(SearchVolunteerPeerResults);
